import { Modal } from '../../components/Modal';
import { useOverlays } from '../../store/overlays';
import { CreateChannelDialog } from '../channel-settings/CreateChannelDialog';
import { NewDmDialog } from '../dms/NewDmDialog';
import { InboxPopover } from '../notifications/InboxPopover';
import { NotificationSettingsDialog } from '../notifications/NotificationSettingsDialog';
import { UserPopout } from '../profile/UserPopout';
import { CreateServerDialog } from '../servers/CreateServerDialog';
import { InviteDialog } from '../servers/InviteDialog';
import { JoinServerDialog } from '../servers/JoinServerDialog';
import { CustomStatusDialog } from '../settings/CustomStatusDialog';

/**
 * Rendert den aktuell offenen globalen Dialog bzw. das Popout (store/overlays). Extras mit `display: 'dialog'`
 * bringen ihr eigenes Dialogfenster mit und werden ohne umschließendes Modal gerendert.
 */
export function GlobalOverlays() {
  const dialog = useOverlays((s) => s.dialog);
  const popout = useOverlays((s) => s.popout);
  const close = useOverlays((s) => s.closeDialog);
  const closePopout = useOverlays((s) => s.closePopout);
  return (
    <>
      {dialog?.type === 'createServer' && <CreateServerDialog onClose={close} />}
      {dialog?.type === 'joinServer' && <JoinServerDialog onClose={close} />}
      {dialog?.type === 'invite' && <InviteDialog serverId={dialog.serverId} channelId={dialog.channelId} onClose={close} />}
      {dialog?.type === 'createChannel' && <CreateChannelDialog serverId={dialog.serverId} parentId={dialog.parentId} defaultType={dialog.defaultType} onClose={close} />}
      {dialog?.type === 'newDm' && <NewDmDialog channelId={dialog.channelId} onClose={close} />}
      {dialog?.type === 'customStatus' && <CustomStatusDialog onClose={close} />}
      {dialog?.type === 'notificationSettings' && <NotificationSettingsDialog serverId={dialog.serverId} channelId={dialog.channelId} onClose={close} />}
      {dialog?.type === 'extra' && dialog.item.component && dialog.item.display === 'dialog' && <dialog.item.component {...dialog.ctx} onClose={close} />}
      {dialog?.type === 'extra' && dialog.item.component && dialog.item.display !== 'dialog' && (
        <Modal title={dialog.item.label} onClose={close} wide testId={`extra-${dialog.item.id}`}>
          <dialog.item.component {...dialog.ctx} onClose={close} />
        </Modal>
      )}
      {popout?.type === 'profile' && <UserPopout userId={popout.userId} serverId={popout.serverId} anchor={popout.anchor} onClose={closePopout} />}
      {popout?.type === 'inbox' && <InboxPopover anchor={popout.anchor} onClose={closePopout} />}
    </>
  );
}
